<template lang="html">
<div>
    <v-container style="text-align: center;">
      <div>
        <h1>{{$t('vision.TITLE')}}</h1>
        <div class="subh1"> {{$t('vision.TEXT')}} </div>
      </div>
      </v-container>

    <v-container>
      <v-layout row wrap align-space-around justify-center row fill-height>
        <v-flex  md4 v-for="card in cards">
          <v-container>
          <v-card elevation="6" color="grey lighten-2">
              <v-img
                :src="card.image"
                aspect-ratio="1.5"
              ></v-img>

              <v-card-title primary-title style="padding-left: 10px; padding-right: 10px; text-align: center;">
                <h3 class="headline mb-0">{{card.title}}</h3>
                </v-card-title>

                <v-card-text style="padding-left: 10px; padding-right: 10px; text-align: justify;">
                <h3 align-center v-html="card.text"></h3>
              </v-card-text>

            </v-card>
          </v-container>
          </v-flex>
      </v-layout>
    </v-container>
</div>
</template>

<script>
export default {
  data() {
    return {
      cards: [{
        image: require('../../public/img/Beta Digitis - Gif 2_2-61.png'),
        title: this.$t('vision.item1.TITLE'),
        text: this.$t('vision.item1.TEXT')
      }, {
        image: require('../../public/img/Beta Digitis - Gif 2_2-208.png'),
        title: this.$t('vision.item2.TITLE'),
        text: this.$t('vision.item2.TEXT')
      }, {
        image: require('../../public/img/Beta Digitis - Gif 2_2-390.png'),
        title: this.$t('vision.item3.TITLE'),
        text: this.$t('vision.item3.TEXT')
      }]
    }
  }
}
</script>

<style lang="css" scoped>
</style>
